import api from 'utils/api';
import {TechnicalIssueData} from '@ui/Header/Menu/TechnicalSupport/types';
import {PageSchema, ParamsType} from 'utils';
import {PaginatedResponse} from 'types/pagination';
import {TechnicalSupportIssue} from '@features/TechnicalSupport/types';
import {TechnicalIssueStatus} from './types';

const ROOT_URL = '/support/tickets';

const createTechnicalIssue = (data: TechnicalIssueData) => {
    return api.post(`${ROOT_URL}`, data);
};

const getTableSchema = () => {
    return api.get<PageSchema>(`${ROOT_URL}/table-view/schema`);
};

const getTableData = (params: ParamsType) => {
    return api.get<PaginatedResponse<TechnicalSupportIssue[]>>(`${ROOT_URL}/table-view`, params);
};

const changeTechnicalIssueStatus = (id: number, status: TechnicalIssueStatus) => {
    return api.post(`${ROOT_URL}/${id}/status`, {status});
};

const getTechnicalIssue = (id: string) => {
    return api.get<TechnicalSupportIssue>(`${ROOT_URL}/${id}`);
};

export const TechnicalSupportService = {
    createTechnicalIssue,
    getTableSchema,
    getTableData,
    changeTechnicalIssueStatus,
    getTechnicalIssue,
};
